export const tagColors = {
  Allenamento: "bg-purple-600",
  "Esercizi in palestra": "bg-blue-500",
};